// src/pages/Monografia/SubmeterMonografiaPage.jsx
import React from 'react';
import MonografiaForm from '../../components/Monografia/MonografiaForm';

const SubmeterMonografiaPage = () => {
    return (
        <div>
            <h1>Submeter Monografia</h1>
            <MonografiaForm onSuccess={() => alert('Monografia submetida com sucesso!')} />
        </div>
    );
};

export default SubmeterMonografiaPage;